module.exports = __webpack_public_path__ + "static/assets/06b8b81e4596f360738c678f6a840dc2.svg";